export const channelsMap = {
   amo: {
      channelIcon: '/assets/icons/add-crm-amo-icon.svg',
      channelName: 'amoCRM'
   },
   bitrix: {
      channelIcon: '/assets/icons/add-crm-bitrix-icon.svg',
      channelName: 'Битрикс24'
   }
}